export const GET_DATA_ERROR = "GET_DATA_ERROR";

export const GET_SHOPPING_CART = "GET_SHOPPING_CART";
export const SET_SHOPPING_CART = "SET_SHOPPING_CART";

export const GET_SHIPPING_ADDRESS = "GET_SHIPPING_ADDRESS";
export const SET_SHIPPING_ADDRESS = "SET_SHIPPING_ADDRESS";
